import {
    useState,
    createContext,
    use,
    ReactElement,
    FunctionComponent,
    PropsWithChildren,
} from "react";
import { STATUS_PAGE_URL } from "@/constants";
import ErrorUI from "@/components/ui/error-ui";
import { Button } from "@/components/ui/button";

export type IErrorContextType = {
    statusCode?: number;
    setStatusCode: (statusCode: number) => void;
};

const ErrorContext = createContext<IErrorContextType>({
    statusCode: undefined,
    setStatusCode: () => {
        console.warn("No context setStatusCode handler has been set.");
    },
});

export const useError = () => use(ErrorContext);

export const ErrorProvider: FunctionComponent<PropsWithChildren> = ({
    children,
}): ReactElement => {
    const [statusCode, setStatusCode] = useState<number | undefined>(undefined);

    return (
        <>
            <ErrorContext value={{ setStatusCode }}>
                {statusCode === 429 || statusCode === 503 ? (
                    <ErrorUI
                        type="cover"
                        title={`Sorry, Illuminate is unavailable`}
                        description={
                            <>
                                <p>
                                    Please visit our{" "}
                                    {/* Note that this is an `a` tag instead of a Link, because it is rendered outside of the ReactRouter context */}
                                    <a
                                        href={STATUS_PAGE_URL}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-link-default hover:text-link-hover active:text-link-press cursor-pointer hover:underline"
                                    >
                                        status page
                                    </a>{" "}
                                    for updates, or refresh the page to try
                                    again.
                                </p>
                                <p>(Error code {statusCode})</p>
                            </>
                        }
                        actionButtons={[
                            <Button onClick={() => window.location.reload()}>
                                Refresh page
                            </Button>,
                        ]}
                    />
                ) : (
                    children
                )}
            </ErrorContext>
        </>
    );
};
